import React from 'react'
import '../../App.css'
import { WeatherTable } from '../WeatherTable'
import { WeatherLinks } from '../WeatherLinks'

export const Weather = () => {
  return (
    <>
     <WeatherLinks/>
    <WeatherTable/>
   
    </>
  )
}
